module.exports = __webpack_public_path__ + "static/poppins-v5-latin-600italic-5391564692e7e4c15436fb36d2afb748.svg";